// 若是企微内核浏览器 => 若是mac或windows系统浏览 返回true
export const handleUserAgent = () => {
  const ua = navigator.userAgent;
  return (
    /micromessenger|wxwork/i.test(ua) &&
    /mac|windows/i.test(ua)
  );
};

export const ENV = (document.querySelector('meta[name="x-server-env"]') || { content: 'dev' }).content;

const urlCollect = {
  // 开发环境，开发环境基本不用，先注释掉
  // dev: {
  //   mock: '/mock',
  //   menu: '//dev.xiaoyuanhao.com/menu',
  //   user: '//dev.xiaoyuanhao.com/xjf',
  //   auth: '//test.xiaoyuanhao.com:39003/auth/xyhauth',
  //   recruit: 'http://dev.xiaoyuanhao.com/cx/cx-nbugs-activity/web/county',
  //   meetingSign: '//test-deploy.api.xiaoyuanhao.com/yunzhi-notice-v2-test/web',
  //   studentAttendance: '//dev18.xiaoyuanhao.com/sh-attendance3',
  //   fileApi: '//file.xiaoyuanhao.com',
  //   webApi: '//test-deploy.api.xiaoyuanhao.com',
  //   settingApi: '//test.xiaoyuanhao.com:39027/sentinel',
  //   noticeApi: '//dev18.xiaoyuanhao.com/jdm_notice/web', // 通知公告api
  //   bridgeApi: '//test-deploy.api.xiaoyuanhao.com/nbugs-bridge-test-qa', // 通知鹊桥api
  //   countAPI: '//test-deploy.api.xiaoyuanhao.com/counter-static-jar-qa/counter-static', // 阅读统计
  //   contacts: '//test-deploy.api.xiaoyuanhao.com/cloud-contacts-test',
  //   tool: 'https://sync-task.api.xiaoyuanhao.com',
  //   tags: '//test-deploy.api.xiaoyuanhao.com/tag-manage-qa',
  //   log: 'http://test-deploy.api.xiaoyuanhao.com/operation-log-component-test',
  //   url: 'http://test-deploy.api.xiaoyuanhao.com/cloud-contacts-test',
  //   safeClock: '//dev18.xiaoyuanhao.com/jdm_notice/web', // 平安钟api
  //   authApi: '//test-deploy.api.xiaoyuanhao.com/nbugs-auth-center-qa', // 用户中心获取应用接口域名
  //   salaryApi: '//test-deploy.api.xiaoyuanhao.com/yunzhi-notice-v2-test/web', // 工资条
  //   dataReport: '//test-deploy.api.xiaoyuanhao.com/yunzhi-notice-test/web', // 数据填报api
  //   o2oa: '//sloa.api.xiaoyuanhao.com:40194', // o2oa
  //   activitySign: '//test-deploy.api.xiaoyuanhao.com/yunzhi-interaction-test/web', // 活动打卡
  //   read: '//aly-test.api.xiaoyuanhao.com/yunzhi-statistic-module-test/web', // 阅读组件
  //   workFlow: '//aly-test.api.xiaoyuanhao.com/yunzhi-data-test/web', // 工作流
  // },
  // 测试环境
  test: {
    mock: '/mock',
    menu: '//aly-test.api.xiaoyuanhao.com/nbugs-permission-center-test',
    user: '//aly-test.api.xiaoyuanhao.com/sh-user-center-test',
    auth: '//aly-test.api.xiaoyuanhao.com/nbugs-auth-center-test/xyhauth',
    // 教育扶贫
    poor: '//dev.xiaoyuanhao.com/nbugs_activity',
    // 鹊桥
    qq: '//dev.xiaoyuanhao.com/bridge',
    recruit: '//test-deploy.api.xiaoyuanhao.com/nbugs-activity-recruit-qa/web/county',
    meetingSign: 'http://test-deploy.api.xiaoyuanhao.com/yunzhi-notice-v2-test/web',
    studentAttendance: 'http://test-deploy.api.xiaoyuanhao.com/yunzhi-safety-test',
    // studentAttendance: '//dev18.xiaoyuanhao.com/sh-attendance3',
    fileApi: '//file.xiaoyuanhao.com',
    webApi: '//test-deploy.api.xiaoyuanhao.com',
    settingApi: '//test.xiaoyuanhao.com:39027/sentinel',
    noticeApi: '//aly-test.api.xiaoyuanhao.com/yunzhi-notice-test/web', // 通知公告api
    bridgeApi: '//test-deploy.api.xiaoyuanhao.com/nbugs-bridge-test-qa', // 通知鹊桥api
    countAPI: '//aly-test.api.xiaoyuanhao.com/counter-static-test/counter-static', // 阅读统计
    contacts: '//aly-test.api.xiaoyuanhao.com/cloud-contacts-test',
    tool: 'https://sync-task.api.xiaoyuanhao.com',
    tags: '//aly-test.api.xiaoyuanhao.com/tag-manage-test',
    log: 'http://aly-test.api.xiaoyuanhao.com/operation-log-component-test',
    url: 'http://aly-test.api.xiaoyuanhao.com/cloud-contacts-test',
    safeClock: '//aly-test.api.xiaoyuanhao.com/yunzhi-notice-test/web', // 平安钟api
    authApi: '//aly-test.api.xiaoyuanhao.com/nbugs-auth-center-test', // 用户中心获取应用接口域名
    dataReport: '//aly-test.api.xiaoyuanhao.com/yunzhi-notice-test/web', // 数据填报api
    salaryApi: '//test-deploy.api.xiaoyuanhao.com/yunzhi-notice-v2-test/web', // 工资条
    o2oa: '//sloa.api.xiaoyuanhao.com:40194', // o2oa
    activitySign: '//aly-test.api.xiaoyuanhao.com/yunzhi-interaction-test/web', // 活动打卡
    read: '//aly-test.api.xiaoyuanhao.com/yunzhi-statistic-module-test/web', // 阅读组件
    workFlow: '//aly-test.api.xiaoyuanhao.com/yunzhi-data-test/web', // 工作流
  },
  // 预发环境
  pre: {
    mock: '/mock',
    menu: '//aly-test.api.xiaoyuanhao.com/nbugs-permission-center-test',
    user: '//aly-test.api.xiaoyuanhao.com/sh-user-center-test',
    auth: '//aly-test.api.xiaoyuanhao.com/nbugs-auth-center-test/xyhauth',
    // 教育扶贫
    poor: '//dev.xiaoyuanhao.com/nbugs_activity',
    // 鹊桥
    qq: '//dev.xiaoyuanhao.com/bridge',
    recruit: '//test-deploy.api.xiaoyuanhao.com/nbugs-activity-recruit-qa/web/county',
    meetingSign: 'http://test-deploy.api.xiaoyuanhao.com/yunzhi-notice-v2-test/web',
    studentAttendance: 'http://test-deploy.api.xiaoyuanhao.com/yunzhi-safety-test',
    // studentAttendance: '//dev18.xiaoyuanhao.com/sh-attendance3',
    fileApi: '//file.xiaoyuanhao.com',
    webApi: '//test-deploy.api.xiaoyuanhao.com',
    settingApi: '//test.xiaoyuanhao.com:39027/sentinel',
    noticeApi: '//aly-test.api.xiaoyuanhao.com/yunzhi-notice-test/web', // 通知公告api
    bridgeApi: '//test-deploy.api.xiaoyuanhao.com/nbugs-bridge-test-qa', // 通知鹊桥api
    countAPI: '//aly-test.api.xiaoyuanhao.com/counter-static-test/counter-static', // 阅读统计
    contacts: '//aly-test.api.xiaoyuanhao.com/cloud-contacts-test',
    tool: 'https://sync-task.api.xiaoyuanhao.com',
    tags: '//aly-test.api.xiaoyuanhao.com/tag-manage-test',
    log: 'http://aly-test.api.xiaoyuanhao.com/operation-log-component-test',
    url: 'http://aly-test.api.xiaoyuanhao.com/cloud-contacts-test',
    safeClock: '//aly-test.api.xiaoyuanhao.com/yunzhi-notice-test/web', // 平安钟api
    authApi: '//aly-test.api.xiaoyuanhao.com/nbugs-auth-center-test', // 用户中心获取应用接口域名
    dataReport: '//aly-test.api.xiaoyuanhao.com/yunzhi-notice-test/web', // 数据填报api
    salaryApi: '//test-deploy.api.xiaoyuanhao.com/yunzhi-notice-v2-test/web', // 工资条
    o2oa: '//sloa.api.xiaoyuanhao.com:40194', // o2oa
    activitySign: '//aly-test.api.xiaoyuanhao.com/yunzhi-interaction-test/web', // 活动打卡
    read: '//aly-test.api.xiaoyuanhao.com/yunzhi-statistic-module-test/web', // 阅读组件
    workFlow: '//aly-test.api.xiaoyuanhao.com/yunzhi-data-test/web', // 工作流
  },
  // 生产环境
  production: {
    mock: '/mock',
    menu: '//perm.api.xiaoyuanhao.com',
    user: '//user.api.xiaoyuanhao.com',
    auth: '//auth.xiaoyuanhao.com/xyhauth',
    // 教育扶贫
    poor: '//help-poor.api.xiaoyuanhao.com',
    // 鹊桥
    qq: '//bridge.api.xiaoyuanhao.com',
    recruit: '//recruit.api.xiaoyuanhao.com/web/county',
    meetingSign: '//notice.api.xiaoyuanhao.com/web',
    studentAttendance: '//safety.api.xiaoyuanhao.com',
    fileApi: '//file.xiaoyuanhao.com',
    webApi: '//microsit.xiaoyuanhao.com/wz',
    settingApi: '//sentinel.api.xiaoyuanhao.com',
    noticeApi: '//notice.api.xiaoyuanhao.com/web', // 通知公告api
    bridgeApi: '//bridge.api.xiaoyuanhao.com', // 通知鹊桥api
    countAPI: '//counter.api.xiaoyuanhao.com/counter-static', // 阅读统计
    contacts: '//gateway.api.xiaoyuanhao.com/contacts',
    tool: 'https://sync-task.api.xiaoyuanhao.com',
    tags: '//tag.api.xiaoyuanhao.com',
    log: 'https://gateway.api.xiaoyuanhao.com/operation-log',
    url: 'https://gateway.api.xiaoyuanhao.com/contacts',
    safeClock: '//notice.api.xiaoyuanhao.com/web', // 平安钟api
    authApi: '//auth.xiaoyuanhao.com', // 用户中心获取应用接口域名
    salaryApi: '//notice.api.xiaoyuanhao.com/web', // 工资条
    dataReport: '//notice.api.xiaoyuanhao.com/web', // 数据填报api
    o2oa: '//sloa.api.xiaoyuanhao.com:40194', // o2oa
    activitySign: '//clock2.api.xiaoyuanhao.com/yunzhi-interaction/web', // 活动打卡
    read: '//yunzhi-statistic-module.api.xiaoyuanhao.com/web', // 阅读组件
    workFlow: '//yunzhi-data.api.xiaoyuanhao.com/web', // 工作流导出统计
  }
};

// 开发环境基本不用，直接映射成测试环境
urlCollect.dev = urlCollect.test;

export const url = urlCollect[ENV];

export const gotoLogin = (path, isSelect) => {
  window.location.href = `http${ENV === 'production' ? 's://login' : '://login-test'}.xiaoyuanhao.com/${!isSelect ? 'user/login' : 'select'}?destination=${encodeURIComponent(path || window.location.href)}`;
};

export function funVerifySuccess() {
  const PN = window.location.pathname;
  let res = !0;
  ['iframe', 'o2oa', 'RDP-SERVER', 'msgsend'].map(item => {
    if (PN.indexOf(item) !== -1) {
      res = !1;
    }
    return !1;
  });
  return res;
}
